import CustomSelectFile from "../../comman/CustomSelectFile";
import { SHOP_TYPE_ENUM } from "../../utils/Constant";

const BasicDetails = ({ formikProp }) => {
  const {
    values,
    handleChange,
    setFieldValue,
    touched,
    errors,
    onLocationToggle,
  } = formikProp;

  const renderError = (field) =>
    touched[field] && errors[field] ? (
      <span className="text-danger" style={{ fontSize: "14px" }}>
        {errors[field]}
      </span>
    ) : null;

  return (
    <>
      {/* Left Section */}
      <div className="col-md-8">
        <div className="tabData mt-4">
          <h6>Enter the details below for create/edit Branches</h6>

          <div className="mt-2 mb-2">
            <div className="dashbed-border-bottom" />
          </div>

          <div className="pb-4">
            <div className="row">
              {/* Branch Name */}
              <div className="col-md-12 mb-3">
                <div className="form-group">
                  <label>
                    Branch Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Branch Name"
                    name="branchName"
                    value={values.branchName || ""}
                    onChange={handleChange}
                  />
                  {renderError("branchName")}
                </div>
              </div>

              {/* Lowest Price */}
              <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label>
                    Lowest Price <span className="text-danger">*</span>
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Lowest Price"
                    name="lowestPrice"
                    value={values.lowestPrice || ""}
                    onChange={handleChange}
                  />

                  {renderError("lowestPrice")}
                </div>
              </div>

              {/* Shop Type */}
              <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label>
                    Shop Type <span className="text-danger">*</span>
                  </label>

                  <select
                    className="form-control"
                    name="shopType"
                    value={values.shopType}
                    onChange={(e) =>
                      setFieldValue("shopType", e.target.value)
                    }
                  >
                    <option value={SHOP_TYPE_ENUM.STATIC}>Static</option>
                    <option value={SHOP_TYPE_ENUM.MOBILE}>Van</option>
                  </select>
                </div>
              </div>

              {/* Location Toggle */}
              {values.shopType === SHOP_TYPE_ENUM.MOBILE && (
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <label className="d-block">
                      Location Enable
                    </label>

                    <label className="switch mb-0">
                      <input
                        type="checkbox"
                        name="locationEnable"
                        checked={values.locationEnable}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setFieldValue("locationEnable", checked);
                          onLocationToggle?.(checked);
                        }}
                      />
                      <span className="slider round" />
                    </label>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Right Section */}
      <div className="col-md-4">
        <CustomSelectFile
          id="thumbnail"
          title="Thumbnail (Jpeg, PNG, JPG)"
          files={values.thumbnail}
          onChange={(file) => setFieldValue("thumbnail", file)}
          error={Boolean(touched.thumbnail && errors.thumbnail)}
          helperText={touched.thumbnail && errors.thumbnail}
          imgSx={{ width: "100%", height: "auto" }}
        />

        <div className="card mt-3">
          <div className="card-header">
            <h5 className="mb-0">
              <button
                type="button"
                className="btn btn-link text-black shadow-none pl-0 pb-0 staturightghead"
              >
                Status Update
              </button>
            </h5>
          </div>

          <div className="card-body">
            <label className="logCheck mb-3">
              <input
                type="radio"
                name="statusupdate"
                value="ACTIVE"
                checked={values.statusupdate === "ACTIVE"}
                onChange={handleChange}
              />
              <div>Active</div>
              <span className="checkmark" />
            </label>

            <label className="logCheck mb-0">
              <input
                type="radio"
                name="statusupdate"
                value="INACTIVE"
                checked={values.statusupdate === "INACTIVE"}
                onChange={handleChange}
              />
              <div>Inactive</div>
              <span className="checkmark" />
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicDetails;